/* Anemoia Letters (custom): the CRT folders row + the vintage Word window.
   Progressive: without JS the welcome folder is an inert button and the letter
   stays hidden; the Back link still works as a plain <a>. */
(() => {
  class AnemoiaLetters extends HTMLElement {
    connectedCallback() {
      /* Backdrop loops + the WebGL CRT curvature glass (shared with the CRT
         desktop page; loaded from anemoia-desktop-fx.js just before this). */
      window.AnemoiaDesktopFX?.initBackdrop(this);
      window.AnemoiaDesktopFX?.initCrt(this);
      this.wordView = this.querySelector('[data-letters-word]');
      this.windowEl = this.querySelector('[data-letters-window]');
      this.openBtn = this.querySelector('[data-letters-open]');
      this.backBtn = this.querySelector('[data-letters-back]');
      if (!this.wordView || !this.openBtn) return;

      this.openBtn.addEventListener('click', () => this.openWord());

      this.querySelectorAll('[data-letters-close]').forEach((el) => {
        el.addEventListener('click', () => this.closeWord());
      });

      /* Locked folders: an XP "access denied" shake instead of navigation. */
      this.querySelectorAll('[data-letters-locked]').forEach((btn) => {
        btn.addEventListener('click', () => {
          btn.classList.remove('is-denied');
          void btn.offsetWidth;
          btn.classList.add('is-denied');
        });
      });

      /* The one Back button does double duty: with the letter open it closes
         back to the folders (in-page, no reload); on the folders view it is a
         plain link back to /pages/world. Never through the monitor dive. */
      if (this.backBtn) {
        this.backBtn.addEventListener('click', (event) => {
          if (this.classList.contains('is-word')) {
            event.preventDefault();
            this.closeWord();
          }
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.classList.contains('is-word')) this.closeWord();
      });
    }

    openWord() {
      window.clearTimeout(this.hideTimer);
      this.wordView.hidden = false;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.classList.add('is-word'));
      });
      if (this.windowEl) this.windowEl.focus({ preventScroll: true });
    }

    closeWord() {
      this.classList.remove('is-word');
      /* Matches the 0.25s opacity/scale transition in the section CSS. */
      this.hideTimer = window.setTimeout(() => {
        this.wordView.hidden = true;
      }, 260);
      this.openBtn.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('anemoia-letters')) customElements.define('anemoia-letters', AnemoiaLetters);
})();
